<template>
    <div class="wrapper -ficha-noticia" v-if="entry">
        <div class="container row-between top-noticia">
            <div class="breadcrumb">
                <nav class="container row-start">
                    <router-link :to="{ name: 'home' }">Hiper Usera</router-link>
                    <router-link :to="{ name: 'noticias' }">Noticias</router-link>
                    <a>{{ entry.title }}</a>
                </nav>
            </div>
            <router-link class="back" :to="{ name: 'noticias' }">Volver</router-link>
        </div>

        <section class="cuerpo-noticia">
            <h2>{{ entry.title }}</h2>
            <div class="imagen-principal">
                <img :src="entry.header_img.url" :alt="entry.title">
            </div>
            <h3>{{ entry.header }}</h3>
            <h4 class="fecha">{{ fecha }}</h4>
            <div class="contenedor-texto-editor">
                <editor :object="entry.description"></editor>
            </div>
            <nav class="share row-start">
                <span>Compartir</span>
                <a target="_blank" :href="`http://www.facebook.com/sharer.php?u=${full_route}&t=${entry.name}`">
                    <img src="@/assets/img/facebook-green.svg" alt="Facebook">
                </a>

                <a target="_blank" :href="`http://twitter.com/intent/tweet?url=${full_route}&text=${entry.name}`">
                    <img src="@/assets/img/twitter-green.svg" alt="Twitter" style="min-width: 25px;">
                </a>
                <a target="_blank" :href="`https://www.linkedin.com/shareArticle?mini=false&url=${full_route}&title=${entry.name}`">
                    <img src="@/assets/img/linkedin-green.svg" alt="Linkedin">
                </a>
            </nav>
            <img class="te-cuida" src="@/assets/img/logo-te-cuida.png" alt="Te cuida" width="80">
        </section>

    </div>
</template>

<script>
import { entriesStore } from '@/store/entries'
import editor from '@/components/editor-js';
export default {
    name: 'ficha-noticia',
    props: ['slug'],
    components: {
        editor
    },
    data() {
        const store = entriesStore();
        return {
            store: store,
            entry: null,
        }
    },
    computed: {
        fecha() {
            return this.dayjs(this.entry.publish_date).format('DD MMMM YYYY');
        },
        full_route() {
            return window.location.href;
        }
    },
    mounted() {
        let t = this;
        this.entry = this.store.getEntry(this.slug);
        if (this.entry == null) {
            this.store.getEntryCall({ slug: this.slug }).then(function (result) {
                t.entry = result.data;
                t.changeMetaUrl()
            });
        }else{
            t.changeMetaUrl()
        }
    },
    methods: {
        changeMetaUrl: function () {
            let title = this.entry.title
            let description = this.entry.header

            document.title = title
            document.head.querySelector("[name=description]").content = description
            document.head.querySelector("[name=title]").content = title
            //
            document.head.querySelector("[property='og:title']").content = title;
            document.head.querySelector("[property='og:image']").content = this.entry.header_img.url;
            document.head.querySelector("[property='og:description']").content = description
            //
            document.head.querySelector("[name='twitter:title']").content = title;
            document.head.querySelector("[name='twitter:description']").content = description;
            document.head.querySelector("[name='twitter:image']").content = this.entry.header_img.url;
            document.head.querySelector("[name='twitter:text:title").content = title;
        },
    }
}
</script>
